export default "__VITE_ASSET__BaMbC437__"